import { gql } from 'graphql-request'
import { GenericBlock } from './generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { contentFragments } from 'app/queries/content/all-content-list'

export const latestGridFragment = gql`
  ${contentFragments}
  fragment latestGridFragment on LatestGrid {
    id
    title
    content {
      ...content
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface LatestGrid extends GenericBlock<'LatestGrid'> {
  title: string
  content: any[]
  excludedPlatforms: ExcludedPlatforms
}
